import isArray from 'lodash/isArray';

import {AdditionalProps} from '../types';

type QueryValue = string | string[] | undefined;
type QueryObject = Record<string, QueryValue>;

const getSkipProp = (query: QueryObject): AdditionalProps['skip'] => {
  if (typeof query.skip === 'string') {
    // Format: ?skip=intro,age
    return query.skip.split(',') as AdditionalProps['skip'];
  }

  if (isArray(query.skip)) {
    // Format: ?skip=intro&skip=age
    return query.skip as AdditionalProps['skip'];
  }

  return [];
};

export default getSkipProp;
